import {createSelector} from '@reduxjs/toolkit';

import {TAppState} from 'store/config/types';
import {AIS3_SLICE} from 'store/slices/ais-slice/ais-slice-constants';

const selectTAisSliceState = (state: TAppState) => state[AIS3_SLICE];

export const selectForecastCommentsCommon = createSelector(
    selectTAisSliceState,
    ({forecastComments}) => forecastComments
);

export const selectForecastCommentsTable = createSelector(
    selectForecastCommentsCommon,
    (commonData) => commonData?.tableData?.dataTable
);

export const selectForecastCommentsFilters = createSelector(selectForecastCommentsCommon, (commonData) => ({
    requestId: commonData?.requestId,
    status: commonData?.status,
    taxCode: commonData?.taxCode,
    plannedResponseDate: commonData?.plannedResponseDate,
    createdResponseDate: commonData?.createdResponseDate,
}));
